import React from "react";
import { useLocation } from "react-router-dom";
import AuthHeader from "../../components/header/AuthHeader";
import PasswordlessLogin from "../../components/auth/PasswordlessLogin";

function Login() {
  const { search } = useLocation();
  const expired = new URLSearchParams(search).get("session") === "expired";

  return (
    <PasswordlessLogin
      notice={
        expired
          ? "Votre session a expiré, veuillez vous reconnecter."
          : undefined
      }
      header={<AuthHeader />}
      otpPath="/auth-otp"
      signupPath="/register"
    />
  );
}

export default Login;
